import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum BannerFilterKeys {
  started = "started",
  status = "status"
}

export interface BannerListFilterOpts {
  started: FilterOpts<MinMax>;
  status: FilterOpts<SmopStatusEnum>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "banner status"
  },
  expired: {
    defaultMessage: "Expired",
    description: "banner status"
  },
  fixed: {
    defaultMessage: "Fixed amount",
    description: "banner type"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "banner type"
  },
  percentage: {
    defaultMessage: "Percentage",
    description: "banner type"
  },
  scheduled: {
    defaultMessage: "Scheduled",
    description: "banner status"
  },
  started: {
    defaultMessage: "Started",
    description: "banner start date"
  },
  status: {
    defaultMessage: "Status",
    description: "banner status"
  },
  type: {
    defaultMessage: "Banner Type"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: BannerListFilterOpts
): IFilter<BannerFilterKeys> {
  return [
    {
      ...createDateField(
        BannerFilterKeys.started,
        intl.formatMessage(messages.started),
        opts.started.value
      ),
      active: opts.started.active
    },
    {
      ...createOptionsField(
        BannerFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        [
          {
            label: intl.formatMessage(messages.active),
            value: SmopStatusEnum.ACT
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: SmopStatusEnum.INA
          }
        ]
      ),
      active: opts.status.active
    }
  ];
}
